<template>
  <div id="app">
    <SemcogHeader>
      <span class="title" style="line-height: 2em;">
        Laborshed - Linking Residents to Workplaces
      </span>
    </SemcogHeader>
    <mainmap
      v-bind:mcdFilter="mcdFilter"
      v-bind:counties="counties"
      v-bind:mappedAmenity="mappedAmenity"
      v-bind:mappedCategory="mappedCategory"
      v-bind:flowDirection="flowDirection"
      v-on:countiesInput="counties = sort($event)"
      v-on:categoryInput="mappedCategory = $event"
      v-on:mcdInput="mcdFilter = sort($event)"
      v-on:input="mappedAmenity = $event"
      v-on:flowDirection="flowDirection = $event"
    />
  </div>
</template>

<script>
import mainmap from "./components/MainMap";
import SemcogHeader from './components/SemcogHeader.vue';
import {diff} from 'deep-diff';

export default {
  name: 'app',
  components: {
    mainmap, SemcogHeader
  },
  data: function () {

    let qmcd = this.$route.query.mcd;
    let qcounty = this.$route.query.county;

    let county = [];
    if (qcounty) {
      if (Array.isArray(qcounty)) {
        county = qcounty.map(m => {return {statevalue:parseInt(m, 10)}});
      } else {
        county = [{statevalue: parseInt(qcounty, 10)}]
      }
    }

    let qcategory = this.$route.query.category;
    let mappedCategory =  'Industry';
    let flowDirection = 'Outflow';
    if (qcategory === 'Occupation') {
      mappedCategory = qcategory
    } else if (qcategory) {
      mappedCategory = 'Flow'
      flowDirection = qcategory
    }

    return {
      mcdFilter: (Array.isArray(qmcd) ? qmcd.map(m => parseInt(m, 10)) : parseInt(qmcd, 10)) || 0,
      counties: county,
      mappedAmenity: this.$route.query.amenity || 'Residence',
      mappedCategory,
      flowDirection,
    }
  },
  computed: {
    query: function () {
      let out = {};
      if (this.mcdFilter) {
        out.mcd = this.mcdFilter
      }
      if (this.mappedAmenity !== 'Residence') {
        out.amenity = this.mappedAmenity
      }
      if (this.mappedCategory !== 'Industry') {
        if (this.mappedCategory === 'Flow') {
          out.category = this.flowDirection
        } else {
          out.category = this.mappedCategory
        }
      }
      return out
    },
  },
  methods: {
    sort: function (ids) {
      if (ids.sort) {
        return ids.sort((a, b) => a - b);
      }
      return ids;
    }
  },
  watch: {
    query: function (oldVal, newVal) {
      if (diff(oldVal, newVal)) {
        this.$router.replace({
          path: "./",
          query: this.query
        })
      }
    },
  }
}
</script>

<style>
  #app {
    width: 100%;
    height: 100vh;
    display: grid;
    grid-template-rows: max-content auto;
    font-family: Arial, Helvetica, sans-serif;
  }

  @media screen and (max-width: 800px) {
    #app {
      height: initial;
    }
  }

  @media screen {
    .title {
      display: unset;
    }
  }

  @media print {
    @page {
      size: landscape;
    }

    .title {
      display: none;
    }
  }
</style>
